import request from '@/request'
import type { DeviceEventTimeNode, PersonInOutEventItem } from './types'

// 处理设备事件
export const handleDeviceEvent = (params: {
  eventListId: string
}): Promise<ResponseData<object>> => {
  return request.get(`/event/handleFallEvent`, { params })
}

/**
 * 查询设备事件时间节点
 * @description 用于获取设备的跌倒事件回放数据
 */
export const queryDeviceEventTimeNodes = (params: {
  devId: string
  date: string
}): Promise<ResponseData<DeviceEventTimeNode>> => {
  return request.post(`/event/queryEventTimeNode`, params)
}

/**
 * 查询所选事件时间节点文件下载地址
 * @description 用于获取设备事件的文件下载地址合集
 */
export const queryEventTimeNodeFileUrls = (params: {
  devId: string
  date: string
  downloadFallEvent: boolean
  downloadPersonInOutEvent: boolean
  personInOutEvent: PersonInOutEventItem[]
}): Promise<
  ResponseData<{
    fallEventDownloadUrl: string[]
    personInOutEventDownloadUrl: string[]
  }>
> => {
  return request.post(`/event/queryEventTimeNodeFileUrl`, params)
}
